export const $ = <T extends HTMLElement = HTMLElement>(id: string): T | null => document.getElementById(id) as T | null;

export const show = (el: HTMLElement | null): void => {
    if (el) el.classList.remove('hidden');
};

export const hide = (el: HTMLElement | null): void => {
    if (el) el.classList.add('hidden');
};

export const setText = (root: HTMLElement, selector: string, value: string | null | undefined): void => {
    const el = root.querySelector(selector);
    if (el) el.textContent = value ?? '';
};

export const setRowVisibility = (root: HTMLElement, selector: string, value: string | null | undefined): void => {
    const row = root.querySelector(selector);
    if (!row) return;
    if (value && String(value).trim().length > 0) {
        row.classList.remove('hidden');
    } else {
        row.classList.add('hidden');
    }
};
